import exportsReducer from './reducers';
export { default as exportsActions } from './actions';
export default exportsReducer;